import React from 'react';

const Chevron = () => {
  return (
    <svg data-testid="chevron" width="22" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.56055 5.49993L1.25084 10.2787L0.749117 9.72119L5.43941 5.49993L0.749118 1.27866L1.25084 0.721191L6.56055 5.49993Z" fill="#76797C" />
    </svg>
  );
};

export default Chevron;
